import React, { Component } from "react";
import "./MyMapsItems.scss";

class MyMapsItems extends Component {
	state = {};

	render() {
		return (
			<div className="sc-container">
				{/* <div className="sc-mymaps-items-container-header">
					<img src={images["myItemsIcon.png"]} alt="My Maps Icon" />
					<label className={this.props.isEditing ? "sc-mymaps-items-container-header-editing" : "sc-hidden"}>Editing Mode On</label>
				</div> */}
				{/* <div className={this.props.children.props.children.length !== 0 ? "title-h2" : "sc-hidden"}>
					Vytvorené poznámky:
				</div> */}
                <div className="title-h2">Vytvorené poznámky</div>
				<div className={this.props.children.props.children.length === 0 ? "sc-mymaps-items-no-data" : "sc-hidden"}>
					Momentálne neexistujú žiadne kresby. Vytvorte vlastné kresby pomocou nástrojov na kreslenie. 
				</div>
				<div className="sc-mymaps-items-container-list">{this.props.children}</div>
			</div>
		);
	}
}

export default MyMapsItems;

// IMPORT ALL IMAGES
const images = importAllImages(require.context("./images", false, /\.(png|jpe?g|svg)$/));
function importAllImages(r) {
	let images = {};
	r.keys().map((item, index) => (images[item.replace("./", "")] = r(item)));
	return images;
}
